import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import type { PendingRequest } from '../../../lib/teacherApi';
import { approveRequest, rejectRequest } from '../../../lib/teacherApi';

export default function PendingRequestsCard({
  requests,
  onRefresh,
}: {
  requests: PendingRequest[];
  onRefresh: () => Promise<void>;
}) {
  const [busyId, setBusyId] = useState<number | null>(null);

  const handleApprove = async (id: number) => {
    setBusyId(id);
    try {
      await approveRequest(id);
      await onRefresh();
    } finally {
      setBusyId(null);
    }
  };

  const handleReject = async (id: number) => {
    setBusyId(id);
    try {
      await rejectRequest(id);
      await onRefresh();
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Cereri de înscriere</h2>
        <div className="text-xs text-muted-foreground">{requests.length} în total</div>
      </div>

      {requests.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8">
          <Icon name="Inbox" size={48} className="text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground text-center">Nu există cereri în așteptare</p>
        </div>
      ) : (
        <div className="space-y-3">
          {requests.slice(0, 6).map((r) => (
            <div key={r.id} className="p-3 border border-border rounded-md">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground truncate">{r.student_name}</div>
                  <div className="text-xs text-muted-foreground truncate">{r.classroom_name}</div>
                  <div className="mt-1 text-[11px] text-muted-foreground">Stare: {r.status}</div>
                </div>
                <div className="flex items-center gap-2">
                  <Button
                    variant="outline"
                    size="xs"
                    iconName="Check"
                    onClick={() => handleApprove(r.id)}
                    disabled={busyId !== null}
                  >
                    Acceptă
                  </Button>
                  <Button
                    variant="outline"
                    size="xs"
                    iconName="X"
                    onClick={() => handleReject(r.id)}
                    disabled={busyId !== null}
                  >
                    Respinge
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
